<template>
  <div class="container">
    <div class="white-frame">
      <div class="title-text mb-3">
        <b>Dados do Sinistro</b>
      </div>
      <location
        :value="businessLocationObject"
        @locationUpdated="handleLocationUpdates"
        :validationObject="getLocationValidationObject"
        locationSectionName="sinistro"
        :showCountrySelector="showCountrySelector"
        :defaultCountry="getDefaultCountry"
      >
        <template #otherFields>
          <slot name="dadosCoberturas"></slot>
          <div
            class="col-md-6"
            :class="{
              'field-required':
                validation.objDTO.Sinistro.SinistroData.$invalid,
            }"
          >
            <label class="form-label" for="sinistroData">Data Sinistro</label>
            <Calendar
              id="sinistroData"
              v-model="objDTO.Sinistro.SinistroData"
              dateFormat="dd/mm/yy"
              class="form-control p-0"
              disabled
            />
          </div>
          <div
            class="col-md-6"
            :class="{
              'field-required':
                validation.objDTO.Sinistro.SinistroData.$invalid,
            }"
          >
            <label class="form-label" for="sinistroHora">Hora Sinistro</label>
            <Calendar
              id="sinistroHora"
              v-model="objDTO.Sinistro.SinistroData"
              dateFormat="dd/mm/yy"
              :timeOnly="true"
              hourFormat="24"
              :showSeconds="false"
              :manualInput="false"
              class="form-control p-0"
            />
          </div>
          <div
            class="col-md-12"
            :class="{
              'field-required':
                validation.objDTO.Sinistro.SinistroDescricao.$invalid,
            }"
          >
            <label class="form-label" for="sinistroDesc"
              >Descrição da Ocorrência</label
            >
            <Textarea
              id="sinistroDesc"
              v-model="objDTO.Sinistro.SinistroDescricao"
              :autoResize="true"
              rows="5"
              cols="30"
              :maxlength="1000"
              class="form-control"
            />
          </div>
        </template>
      </location>
    </div>
  </div>
</template>

<script>
import Location from '../../shared/Location.vue';
import { mapGetters } from 'vuex';
import GenericLocation from '../../../utils/classes/GenericLocation';
import { locationDefaultObject } from '../../../utils/constants';

export default {
  components: { Location },
  props: {
    events: {
      type: Array,
      default: () => [],
    },
    isLoadingEvents: {
      type: Boolean,
      default: false,
    },
    validation: {
      type: Object,
      required: true,
    },
    showCountrySelector: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      businessLocationObject: GenericLocation.createLocationFromObject(
        locationDefaultObject
      ),
      brasilCountryId: 3,
    };
  },
  computed: {
    ...mapGetters({ objDTO: 'getObjDTO' }),
    getDefaultCountry() {
      if (!this.showCountrySelector) {
        return {
          Id: 3,
          Description: 'Brasil',
        };
      }

      return undefined;
    },
    isBrasilSelected() {
      // Caso selecionado o país Brasil, o campo Estado deve ser obrigatório.
      return this.objDTO.Sinistro.SinistroPaisId === this.brasilCountryId;
    },
    getLocationValidationObject() {
      const sinistro = this.validation.objDTO.Sinistro;
      return {
        locationObject: {
          address: sinistro.SinistroMorada,
          number: sinistro.SinistroMoradaNrPorta,
          countryId: sinistro.SinistroPaisId,
          stateId: sinistro.SinistroDistritoId,
          stateDescription: sinistro.SinistroDistritoDescripton,
          cityId: sinistro.SinistroConcelhoId,
          cityDescription: sinistro.SinistroConcelhoDescription,
          localityId: sinistro.SinistroFreguesiaId,
          localityDescription: sinistro.SinistroFreguesiaDescription,
        },
      };
    },
  },
  beforeMount() {
    this.businessLocationObject = new GenericLocation(
      this.objDTO.Sinistro.SinistroMorada,
      this.objDTO.Sinistro.SinistroMoradaNrPorta,
      this.objDTO.Sinistro.SinistroPaisId,
      this.objDTO.Sinistro.SinistroPaisDescricao,
      this.objDTO.Sinistro.SinistroDistritoId,
      this.objDTO.Sinistro.SinistroDistritoDescripton,
      this.objDTO.Sinistro.SinistroConcelhoId,
      this.objDTO.Sinistro.SinistroConcelhoDescription,
      this.objDTO.Sinistro.SinistroFreguesiaId,
      this.objDTO.Sinistro.SinistroFreguesiaDescription,
      this.objDTO.Sinistro.SinistroObs
    );
  },
  methods: {
    handleLocationUpdates(locationObject) {
      this.objDTO.Sinistro.SinistroMorada = locationObject.address;
      this.objDTO.Sinistro.SinistroMoradaNrPorta = locationObject.number;
      this.objDTO.Sinistro.SinistroPaisId = locationObject.countryId;
      this.objDTO.Sinistro.SinistroPaisDescricao =
        locationObject.countryDescription;
      this.objDTO.Sinistro.SinistroDistritoId = locationObject.stateId;
      this.objDTO.Sinistro.SinistroDistritoDescripton =
        locationObject.stateDescription;
      this.objDTO.Sinistro.SinistroConcelhoId = locationObject.cityId;
      this.objDTO.Sinistro.SinistroConcelhoDescription =
        locationObject.cityDescription;
      this.objDTO.Sinistro.SinistroFreguesiaId = locationObject.localityId;
      this.objDTO.Sinistro.SinistroFreguesiaDescription =
        locationObject.localityDescription;
      this.objDTO.Sinistro.SinistroObs = locationObject.complement;
    },
    onEventsNatureChange(event) {
      console.log('onSinisterNatureChange', event);
      // this.objDTO.Sinistro.SinistroEventoId = event.value;
      this.$emit('naturezaChanged', event);
    },
  },
};
</script>

<style></style>
